import React, {useState} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";

interface MessageSamplesSwiperProps{
    sampleList:SampleMessageDto[];
    showName?: boolean;
    appendClass?: string;
    handleSelected?:(dto:SampleMessageDto) => void;
}
const MessageSamplesSwiper:React.FC<MessageSamplesSwiperProps> = (
    {
        sampleList = [],
        showName = false,
        appendClass = '',
        handleSelected = () => {}
    }
) => {
    const [selectedSampleCode, setSelectedSampleCode] = useState<string>("");
    const onClickSample = (dto:SampleMessageDto)=> {
        if(dto && dto.code){
            setSelectedSampleCode(dto.code);
        }else {
            setSelectedSampleCode("");
        }
        handleSelected(dto);
    };
    if(sampleList && sampleList.length > 0) {
        return (
            <Swiper className={appendClass}
                    spaceBetween={10}
                    slidesPerView={1.5}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    modules={[Navigation]}
                    breakpoints={{
                        768: {slidesPerView: 4.5}
                    }}
            >
                {sampleList.map( ((sampleDto, idx) => (
                    <SwiperSlide key={`slide_message_template_item_${idx}`}
                                 className={`${selectedSampleCode === sampleDto.code ? 'selected-slide' : ''}`}
                    >
                        <dl className={`sample-msg-slide-dl`}
                            onClick={() => {onClickSample(sampleDto)}}
                        >
                            {showName &&
                                <dt>{sampleDto.title}</dt>
                            }
                            <dd dangerouslySetInnerHTML={{ __html: sampleDto.sample_message.replace(/<br\s*\/?>/g, '\n').replace(/\n/g, '<br />')}}/>
                        </dl>
                    </SwiperSlide>
                )))}
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
            </Swiper>
        );
    }else {
        return <></>;
    }
}
export default MessageSamplesSwiper;